import * as yup from "yup";
import { CONSTANT } from "../../shared/constants/constant-data";

// Custom validation method to check for business email
const commonEmailDomains = ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com"]; // Add common domains here

const isBusinessEmail = (email: string) => {
  const domain = email.split("@")[1];
  return !commonEmailDomains.includes(domain);
};

export const loginValidationSchema = yup.object().shape({
  firstname: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.AUTH_FIRST_NAME_MSG)
    .min(1, CONSTANT.AUTHENTICATION.AUTH_FIRST_NAME_MIN_LENGTH)
    .max(32, CONSTANT.AUTHENTICATION.AUTH_FIRST_NAME_MAX_LENGTH)
    .matches(
      /^[a-zA-Z]+( [a-zA-Z]+)*$/,
      CONSTANT.AUTHENTICATION.AUTH_FIRST_NAME_PATTERN
    ),

  lastname: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.AUTH_LAST_NAME_MSG)
    .min(1, CONSTANT.AUTHENTICATION.AUTH_LAST_NAME_MIN_LENGTH)
    .max(32, CONSTANT.AUTHENTICATION.AUTH_LAST_NAME_MAX_LENGTH)
    .matches(
      /^[a-zA-Z]+( [a-zA-Z]+)*$/,
      CONSTANT.AUTHENTICATION.AUTH_LAST_NAME_PATTERN
    ),



  password: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.SIGN_IN_PASSWORD_REQUIRED)
    .min(12, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MIN_LENGTH)
    .max(20, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MAX_LENGTH)
    .matches(/^\S*$/, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_NO_SPACE)
.matches(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^_\-+=(){}\[\].,:~`|\\;"'<>/])[A-Za-z\d@$!%*?&#^_\-+=(){}\[\].,:~`|\\;"'<>/]{12,20}$/,
  CONSTANT.AUTHENTICATION.AUTH_PASSWORD_FORMAT
)
    ,

    confirmpassword: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.CONFIRM_PASSWORD_REQUIRED)
    .min(12, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MIN_LENGTH)
    .max(20, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MAX_LENGTH)
    .matches(/^\S*$/, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_NO_SPACE)
.matches(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^_\-+=(){}\[\].,:~`|\\;"'<>/])[A-Za-z\d@$!%*?&#^_\-+=(){}\[\].,:~`|\\;"'<>/]{12,20}$/,
  CONSTANT.AUTHENTICATION.AUTH_PASSWORD_FORMAT
),

  rememberMe: yup.boolean(),

  recaptcha: yup.string().nullable(),

  offLineCaptcha: yup.string().nullable(),
});